var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fs-load-page-container"},[_c('img',{attrs:{"src":require("@/assets/pics/transition.png"),"alt":""}}),_c('div',{staticClass:"button",on:{"click":_vm.openWin}},[_vm._v("进入地网无边")])])
}
var staticRenderFns = []

export { render, staticRenderFns }